export default __webpack_public_path__ + "static/media/logo-white.1ed96674.png";